export function getUTCDate(date?: string | number | Date): Date {
  const startDate = date ? new Date(date) : new Date();
  const utcDate = new Date(startDate.getTime() + startDate.getTimezoneOffset() * 60000);

  return new Date(
    Date.UTC(
      utcDate.getUTCFullYear(),
      utcDate.getUTCMonth(),
      utcDate.getUTCDate(),
      utcDate.getUTCHours(),
      utcDate.getUTCMinutes(),
      utcDate.getUTCSeconds(),
    ),
  );
}
